import React from 'react';
import { Route } from 'react-router-dom';
import GroupDashboard from '@/pages/group/GroupDashboard';
import GroupSubscription from '@/pages/group/GroupSubscription';
import CollegeManagement from '@/pages/group/CollegeManagement';
import GroupCollectionReport from '@/pages/group/GroupCollectionReport';
import GroupDueFeeReport from '@/pages/group/GroupDueFeeReport';
import GroupExpensesReport from '@/pages/group/GroupExpensesReport';
import GroupAttendanceReport from '@/pages/group/GroupAttendanceReport';
import GroupSalaryReport from '@/pages/group/GroupSalaryReport';
import GroupAdmissionReport from '@/pages/group/GroupAdmissionReport';
import GroupIncomeExpensesReport from '@/pages/group/GroupIncomeExpensesReport';
import GroupProfitLoss from '@/pages/group/GroupProfitLoss';
import GroupBalanceSheet from '@/pages/group/GroupBalanceSheet';

export const groupAdminRoutes = (
  <React.Fragment>
    <Route path="/group/dashboard" element={<GroupDashboard />} />
    <Route path="/group/subscription" element={<GroupSubscription />} />
    <Route path="/group/colleges" element={<CollegeManagement />} />
    <Route path="/group/collection-report" element={<GroupCollectionReport />} />
    <Route path="/group/due-fee-report" element={<GroupDueFeeReport />} />
    <Route path="/group/expenses-report" element={<GroupExpensesReport />} />
    <Route path="/group/student-attendance" element={<GroupAttendanceReport type="student" />} />
    <Route path="/group/staff-attendance" element={<GroupAttendanceReport type="staff" />} />
    <Route path="/group/salary-report" element={<GroupSalaryReport />} />
    <Route path="/group/admission-report" element={<GroupAdmissionReport />} />
    <Route path="/group/income-expense-report" element={<GroupIncomeExpensesReport />} />
    <Route path="/group/profit-loss" element={<GroupProfitLoss />} />
    <Route path="/group/balance-sheet" element={<GroupBalanceSheet />} />
  </React.Fragment>
);
